import React from 'react';
import { AppleWalletSVG } from '../../../../../../hoc/components/icon/svgs/apple-wallet';
import { GooglePaySVG } from '../../../../../../hoc/components/icon/svgs/google-pay';
import {
	EventAction,
	EventCategory,
	EventKeys,
	EventLabel,
	EventValues,
} from '../../../../../../../services/analytics-interfaces';
import useAnalytics from '../../../../../../../hooks/useAnalytics';
import { getMobileDevice, DEVICES } from '../../../../../../utilities/getMobileDevice';

const DigitalWallet: React.FC<{ walletKey: string }> = ({ walletKey }) => {
	const analytics = useAnalytics();
	const isWalletEnabled = process.env.GATSBY_MOBILE_WALLET_ENDPOINT;
	const url = process.env.GATSBY_MOBILE_WALLET_ENDPOINT + walletKey;
	const device = getMobileDevice();
	const IOS = device === DEVICES.IOS;
	const Android = device === DEVICES.Android;
	const googleWallet = Android ? EventLabel.GoogleWallet : '';

	const sendAnalytics = () => {
		analytics.sendEvent({
			[EventKeys.EventCategory]: EventCategory.Confirmation,
			[EventKeys.Event]: EventValues.GAEvent,
			[EventKeys.EventAction]: EventAction.MobileWallet,
			[EventKeys.EventLabel]: IOS ? EventLabel.AppleWallet : googleWallet, 
		});
	};

	return (
		<>
			{isWalletEnabled && (IOS || Android) && (
				<div className="col-start-1 col-span-12 flex flex-row justify-center text-center whitespace-nowrap">
					<a
						onClick={sendAnalytics}
						href={url}
						target="_blank"
						rel="noopener noreferrer">
						{IOS && <AppleWalletSVG />}
						{Android && <GooglePaySVG />}
					</a>
				</div>
			)}
		</>
	);
};

export default DigitalWallet;
